import React from 'react';
import numeral from 'numeral';

/**
 *
 * @param {*} props
 * @returns
 */
export function ImportesSolPago(props) {
  return (
    <div style={{ display: 'flex', ...props.style }}>
      <span style={{ marginRight: 10 }}>
        <label style={{ marginRight: 5 }}>TOTAL {props.moneda.sCodigo}:</label>
        <span>{numeral(props.dImporteOriginal).format('$0,0.0000')}</span>
      </span>
      <span style={{ marginRight: 10 }}>
        <label style={{ marginRight: 5 }}>PAG:</label>
        <span>{numeral(props.dImportePagado).format('$0,0.0000')}</span>
      </span>
      <span style={{ marginRight: 10 }}>
        <label style={{ marginRight: 5 }}>PEND:</label>
        <span>{numeral(props.dImportePendiente).format('$0,0.0000')}</span>
      </span>
    </div>
  );
}
